// extracted by mini-css-extract-plugin
export default {"list":"scrollableSection_list__HdiWm","item":"scrollableSection_item__H8ALh"};